import * as auth from './auth'
import CalendarService from '@/services/calendar'

const calendar = new CalendarService()

export default {
  auth,
  calendar
}
